module.exports = __webpack_public_path__ + "img/gzh.1ad151c9.jpg";